import socket from '../Core/socketConnect.js';
import HintsUpdateService from './hintsUpdateService.js';

const currentLanguage = data_handler.currentLanguage,
	clientUserFullGid = data_handler.clientUserFullGid,
	currentPageId = data_handler.currentPageId;

const DOMElements = {
	hint1Button: '#msgH1Btn',
	hint2Button: '#msgH2Btn',
	hint3Button: '#msgH3Btn',
	msgN: '#msgN',
	msgH1: '#msgH1',
	msgH2: '#msgH2',
	msgH3: '#msgH3',
};

const hint1Button = document.querySelector(DOMElements.hint1Button),
	hint2Button = document.querySelector(DOMElements.hint2Button),
	hint3Button = document.querySelector(DOMElements.hint3Button),
	msgN = document.querySelector(DOMElements.msgN),
	msgH1 = document.querySelector(DOMElements.msgH1),
	msgH2 = document.querySelector(DOMElements.msgH2),
	msgH3 = document.querySelector(DOMElements.msgH3);

const setLocalStorage = () => {
	window.localStorage.setItem(currentPageId, 0);
};

const confirmMessage = () => {
	let confirm = 'Tips cost you points! Do you still want to call the hint?';

	if (currentLanguage === 'de_DE') {
		confirm =
			'Tipps kosten dich Punkte! Möchtest du den Hinweis dennoch aufrufen?';
	} else if (currentLanguage === 'fr_FR') {
		confirm =
			"Les conseils te coûtent des points ! Tu veux quand même consulter l'indice ?";
	}

	return confirm;
};

const setHint1PageCurr = () => {
	if (window.localStorage.getItem(currentPageId) === '0') {
		// eslint-disable-next-line no-alert
		if (confirm(confirmMessage())) {
			socketGetHint('1');
			window.localStorage.setItem(currentPageId, 100);
			HintsUpdateService.hintsUpdateLoop();
			msgN.classList.remove('active');
			msgH1.classList.add('active');
			msgN.style.top = '-100%';
			msgH1.style.top = '0';
			msgH2.style.top = '100%';
			msgH3.style.top = '200%';
		}
	} else {
		msgN.classList.remove('active');
		msgH1.classList.add('active');
		msgN.style.top = '-100%';
		msgH1.style.top = '0';
		msgH2.style.top = '100%';
		msgH3.style.top = '200%';
	}
};

const setHint2PageCurr = () => {
	if (window.localStorage.getItem(currentPageId) === '100') {
		// eslint-disable-next-line no-alert
		if (confirm(confirmMessage())) {
			socketGetHint('2');
			window.localStorage.setItem(currentPageId, 110);
			msgH2.classList.add('active');
			msgH1.classList.remove('active');
			msgN.style.top = '-200vh';
			msgH1.style.top = '-100vh';
			msgH2.style.top = '0';
			msgH3.style.top = '100vh';
		}
	} else {
		msgH2.classList.add('active');
		msgH1.classList.remove('active');
		msgN.style.top = '-200vh';
		msgH1.style.top = '-100vh';
		msgH2.style.top = '0';
		msgH3.style.top = '100vh';
	}
};

const setHint3PageCurr = () => {
	if (window.localStorage.getItem(currentPageId) === '110') {
		// eslint-disable-next-line no-alert
		if (confirm(confirmMessage())) {
			socketGetHint('3');
			window.localStorage.setItem(currentPageId, 111);
			msgH3.classList.add('active');
			msgH2.classList.remove('active');
			msgN.style.top = '-300%';
			msgH1.style.top = '-200%';
			msgH2.style.top = '-100%';
			msgH3.style.top = '0';
		}
	} else {
		msgH3.classList.add('active');
		msgH2.classList.remove('active');
		msgN.style.top = '-300%';
		msgH1.style.top = '-200%';
		msgH2.style.top = '-100%';
		msgH3.style.top = '0';
	}
};

const updateLSHintCounter = (hint) => {
	switch (hint) {
		case '1':
			window.localStorage.setItem(currentPageId, 100);
			break;
		case '2':
			window.localStorage.setItem(currentPageId, 110);
			break;
		case '3':
			window.localStorage.setItem(currentPageId, 111);
			break;
		default:
			console.log('Someting went wrong');
	}
};

const socketGetHint = (hint) => {
	socket.emit('get-hint', {
		gid: clientUserFullGid,
		hint,
	});
};

const HintsAttemptsAction = {
	bindEvents: () => {
		if (hint1Button) {
			hint1Button.addEventListener('click', setHint1PageCurr);
		}
		if (hint2Button) {
			hint2Button.addEventListener('click', setHint2PageCurr);
		}
		if (hint3Button) {
			hint3Button.addEventListener('click', setHint3PageCurr);
		}
		setLocalStorage();
	},
	hintsSocketListener: () => {
		socket.on('get-hint', function (data) {
			if (data.data.gid === clientUserFullGid) {
				updateLSHintCounter(data.data.hint);
			}
		});
	},
};

export default HintsAttemptsAction;
